module.exports = __webpack_public_path__ + "static/media/nysc1.098a19e4.jpg";